import { render } from "./viewTable.vue?vue&type=template&id=bfbe6d54&scoped=true"
import script from "./viewTable.vue?vue&type=script&lang=js"
export * from "./viewTable.vue?vue&type=script&lang=js"

import "./viewTable.vue?vue&type=style&index=0&id=bfbe6d54&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbe6d54"]])

export default __exports__